<template>
  <v-row>
    <v-col class="mt-2" cols="12" offset-lg="1" lg="10">
      <v-breadcrumbs :items="breadcrumbs" divider=">" class="pl-1 pb-3" />
      <v-card>
        <v-card-title class="theme">
          <v-icon class="white--text">receipt_long</v-icon>
          <span class="headline ml-2 white--text">Company Departments</span>
          <v-spacer />
          <span>
            <v-btn @click="add" depressed class="action rounded-sm white--text"
              >add</v-btn
            >
          </span>
        </v-card-title>
        <v-divider />

        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="departments"
            class="elevation-0 row-pointer"
            hide-default-footer
            @click:row="edit"
          >
            <template v-slot:footer>
              <div class="text-center mt-5">
                <v-btn
                  fab
                  small
                  depressed
                  class="theme"
                  @click="previous"
                  :disabled="pagination.page <= 0"
                >
                  <v-icon small>navigate_before</v-icon>
                </v-btn>
                <span>
                  <v-btn text :disabled="true">{{ pagination.page + 1 }}</v-btn>
                </span>
                <v-btn
                  fab
                  small
                  depressed
                  class="theme"
                  @click="next"
                  :disabled="pagination.disableNext"
                >
                  <v-icon small>navigate_next</v-icon>
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
    <v-snackbar v-model="snackbar" :bottom="true" :right="true">
      {{ snackbarMessage }}
      <v-btn color="pink" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-row>
</template>
<script>
import { mapGetters } from "vuex";

import { Actions } from "@/views/actions";
import { Breadcrumbs } from "@/views/breadcrumbs";
import { Component } from "@/views/component";
import { Constants } from "@/views/constants";
import { TableHeaders } from "@/views/headers";

export default {
  name: Component.Protected.Company.Departments.List,
  data: () => ({
    breadcrumbs: Breadcrumbs.Departments.List,
    headers: TableHeaders.Departments,
    pagination: {
      disableNext: true,
      page: 0,
    },
    search: {
      name: "",
      limit: 20,
      offset: 0,
    },
  }),
  computed: {
    ...mapGetters(["userInfo", "departments"]),
  },
  methods: {
    add() {
      this.$router.push({ name: Component.Protected.Company.Departments.Add });
    },
    edit(item) {
      if (!item || !item.id) return false;
      this.$router.push({
        name: Component.Protected.Company.Departments.Edit,
        params: { id: item.id },
      });
    },
    setup() {
      if (this.userInfo.role !== Constants.Roles.HR) {
        this.$router.go(-1);
        return false;
      }
      this.tempDisable = false;
      this.getDepartments();
    },
    next() {
      if (this.pagination.page < 0) {
        this.pagination.page = 0;
        this.search.offset = 0;
      } else if (this.departments.length >= this.search.limit) {
        this.pagination.disableNext = false;
        this.pagination.page++;
        this.search.offset = this.search.limit * this.pagination.page;
        this.getDepartments();
      }
    },
    previous() {
      this.pagination.page--;
      if (this.pagination.page < 0) {
        this.pagination.page = 0;
        this.search.offset = 0;
      } else {
        this.pagination.disableNext = false;
        this.search.offset = this.search.limit * this.pagination.page;
        this.getDepartments();
      }
    },
    getDepartments() {
      this.$store
        .dispatch(Actions.DepartmentFind)
        .then(() => {
          let len = this.departments.length;
          if ((len < this.search.limit && len > 0) || len === 0) {
            this.pagination.disableNext = true;
          } else if (len === this.search.limit) {
            this.pagination.disableNext = false;
          }
        })
        .catch((e) => {
          console.error(Constants.Departments.Messages.Error.Find, e);
          this.snackbar = true;
          this.snackbarMessage = Constants.Departments.Messages.Error.Find;
        });
    },
  },
  created() {
    if (this.userInfo && this.userInfo.role) {
      this.setup();
    } else {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.setup());
    }
  },
};
</script>